import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

const MetronomeContext = createContext(
  undefined
);

export const MetronomeProvider = ({ children }) => {
  const [callbacks, setCallbacks] = useState({});
  const callbacksRef = useRef(callbacks);
  const idCounterRef = useRef(0);

  const registerCallback = (callback, label = null, args = []) => {
    const key = !!label ?  label : `callback-${idCounterRef.current++}`;
    callbacksRef.current[key] = { callback, args };
    setCallbacks(callbacksRef.current);
    return key;
  };

  const unregisterCallback = (key) => {
    delete callbacksRef.current[key];
    setCallbacks(callbacksRef.current);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      Object.values(callbacks).forEach(({ callback, args }) =>
        callback(...args)
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [callbacks]);

  return (
    <MetronomeContext.Provider value={{ registerCallback, unregisterCallback }}>
      {children}
    </MetronomeContext.Provider>
  );
};

export const useMetronome = () => {
  const context = useContext(MetronomeContext);
  if (context === undefined) {
    throw new Error("useMetronome must be used within a MetronomeProvider");
  }
  return context;
};
export default MetronomeProvider;